<template>
  <v-row>
    <v-col cols="12">
      <v-btn
        @click="$router.go(-1)"
        rounded
        color="secondary"
        depressed
        :block="isMobile()"
      >
        <v-icon left>mdi-arrow-left</v-icon> Voltar</v-btn
      >
    </v-col>
    <v-col cols="12">
      <v-card flat class="mt-2">
        <v-card-title class="font-weight-bold"
          >Atualizar Escolaridade e Cursos</v-card-title
        >
        <v-card-text>
          <v-row>
            <v-col>
              <v-progress-linear
                indeterminate
                v-if="loading"
              ></v-progress-linear>
              <card-escolaridade v-else />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";
import CardEscolaridade from "./components/CardEscolaridade.vue";
export default {
  components: {
    CardEscolaridade,
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("atualizacaoCadastral", [
      "getEscolaridadeAreaFormacao",
      "getDadosCadastrais",
      "getAnexosAtualiz",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async created() {
    this.loading = true;
    await this.getDadosCadastrais();
    await this.getEscolaridadeAreaFormacao();
    await this.getAnexosAtualiz();

    this.loading = false;
  },
};
</script>

<style></style>
